module.exports = __webpack_public_path__ + "static/media/lu.bdeed103.svg";